export const helpersConst = {
  SET_DROPDOWN_HEIGHT: 'SET_DROPDOWN_HEIGHT',
  SET_CAMPAIGN_BOX_TYPE: 'SET_CAMPAIGN_BOX_TYPE',
  SET_HAS_NEXT: 'SET_HAS_NEXT',
  SET_IS_LOADING: 'SET_IS_LOADING',
  SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
};
